import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Phone, MessageCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import HomeSlider from '../components/HomeSlider';
import Services from '../components/Services';
import WhyChooseUs from '../components/WhyChooseUs';
import Testimonials from '../components/Testimonials';
import EnquiryForm from '../components/EnquiryForm';

const Home = () => {
  const { t } = useTranslation();

  return (
    <div>
      <HomeSlider />
      
      {/* Introduction Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-dark-green mb-6 italic">{t('home.intro.tagline')}</h2>
          <div className="w-24 h-1 bg-gold-primary mx-auto mb-8"></div>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto leading-relaxed">
            {t('home.intro.desc').split('VSK ASSOCIATES').map((part, i, arr) => (
              <React.Fragment key={i}>
                {part}
                {i < arr.length - 1 && <span className="font-bold text-dark-green">VSK ASSOCIATES</span>}
              </React.Fragment>
            ))}
          </p>
          <div className="mt-10 flex flex-wrap justify-center gap-4">
            <Link to="/about" className="bg-dark-green text-white px-8 py-3 rounded-lg font-bold hover:bg-dark-green-deep transition-colors flex items-center space-x-2">
              <span>{t('home.intro.learnMore')}</span>
              <ArrowRight size={18} />
            </Link>
            <Link to="/enquiry" className="border-2 border-gold-primary text-gold-primary px-8 py-3 rounded-lg font-bold hover:bg-gold-primary hover:text-white transition-all">
              {t('hero.cta')}
            </Link>
          </div>
        </div>
      </section>

      <Services />

      {/* Benefits / Banner */}
      <section className="py-16 bg-dark-green text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-8">{t('home.cta.title')}</h2>
          <div className="flex flex-wrap justify-center gap-6">
            <div className="flex flex-col items-center">
              <a href="tel:8936835037" className="flex items-center space-x-3 bg-white text-dark-green px-8 py-4 rounded-xl font-bold hover:bg-gold-light transition-colors shadow-lg">
                <Phone size={24} />
                <span>{t('hero.call')}: 8936835037</span>
              </a>
              <span className="text-sm mt-2 font-semibold">+91 9136556703</span>
            </div>
            <a href="https://wa.me/918936835037" className="flex items-center space-x-3 bg-green-whatsapp text-white px-8 py-4 rounded-xl font-bold hover:opacity-90 transition-opacity shadow-lg">
              <MessageCircle size={24} />
              <span>{t('home.cta.whatsapp')}</span>
            </a>
          </div>
        </div>
      </section>

      <WhyChooseUs />
      
      <Testimonials />

      {/* Enquiry Form Section */}
      <section className="py-20 bg-cream-off">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-dark-green mb-4">{t('home.enquiry.title')}</h2>
            <p className="text-gray-600">{t('home.enquiry.subtitle')}</p>
          </div>
          <EnquiryForm />
        </div>
      </section>
    </div>
  );
};

export default Home;
